module.exports = __webpack_public_path__ + "assets/media/sweet.28c58094.svg";